import React from "react";
import Button from "../Button";
import { TextContainer, TextMessage, ImageContainer, ModalFooter } from "./styles";
import { ModalSuccessMessagePropsInterface } from "./interfaces"
//Assets
import correct from "../../assets/img/correct.svg";
import close from "../../assets/icons/close.svg";

const ModalMessage = ({
    text
}: ModalSuccessMessagePropsInterface
): React.ReactElement => {
    return (        
        <div className="modal fade" id="exampleModal"  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-success-message">
                <div className="modal-content">
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <img src={close} alt="fechar"/>
                    </button>
                </div>
                <div className="modal-body">
                    <TextContainer>
                        <TextMessage>{ text }</TextMessage>
                    </TextContainer>
                    <ImageContainer>
                        <img src={correct} alt="sucesso"/>
                    </ImageContainer>
                </div>
                <ModalFooter className="modal-footer">
                    <Button style={{width: 280}} data-dismiss="modal">Voltar a tela anterior</Button>
                </ModalFooter>
                </div>
            </div>
        </div>
    );
}

export default ModalMessage